/**
 * @param url: some string containing an http url with query params
 * @returns the substring query params from the end of the url, including ? char
 */
export var getUrlQueryString = function (url) {
    if (url === void 0) { url = window.location.href; }
    var queryIndex = url.lastIndexOf('?');
    if (queryIndex > 0)
        return url.substring(queryIndex);
    return '';
};
//# sourceMappingURL=getUrlQueryString.js.map